import api from "./api";

// Admin Login
export const login = async (credentials) => {
  const response = await api.post("user/login", credentials);
  return response.data;
};

// Get all users
export const getRepresentatives = async () => {
  const response = await api.get("user/get_all_pratinidhi");
  return response.data.data;
};

// update Pratinidhi
export const updateRepresentative = async (formData) => {
  const response = await api.post("user/edit_pratinidhi", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
// create user
export const createUser = async (userData) => {
  const response = await api.post("user/create_user", userData);
  return response.data;
};

// reset Password
export const resetPassword = async (userId) => {
  const response = await api.post("user/reset_password", { userId: userId });
  return response.data;
};

// update user
export const updateUser = async (userData) => {
  const response = await api.post("user/edit_user_details", userData);
  return response.data;
};

// Get all users
export const getUsers = async () => {
  const response = await api.get("user/get_all_user");
  return response.data;
};

// Get all users
export const getMembers = async (id) => {
  const response = await api.get(`user/get_details/${id}`);
  return response.data;
};

// create member
export const createMember = async (userData) => {
  const response = await api.post("user/add_family_member", userData);
  return response.data;
};

// update member
export const updateMember = async (userData) => {
  const response = await api.post("user/edit_family_details", userData);
  return response.data;
};

// delete member
export const deleteMember = async (id, parentId) => {
  const response = await api.post("user/delete_family", {
    id,
    parentId,
  });
  return response.data;
};

// Get all Cities
export const getCity = async () => {
  const response = await api.get("location/cities");
  return response.data;
};

// Get all district
export const getDist = async () => {
  const response = await api.get("location/districts");
  return response.data;
};

// Get filtered taluka
export const getTaluka = async (id) => {
  const response = await api.get(`location/talukas/${id}`);
  return response.data;
};

// Get filtered village
export const getVillage = async (id) => {
  const response = await api.get(`location/gaams/${id}`);
  return response.data;
};

// Get Old Message
export const getMessage = async () => {
  const response = await api.get("lavajam/message");
  return response.data;
};

// update Message
export const updateMessage = async (message) => {
  const response = await api.post("lavajam/message", { message });
  return response.data;
};

// --- NEW PDF FUNCTIONS ---

// Get PDF by ID
export const getPdfById = async (pdfId) => {
  const response = await api.get(`pdfs/get_pdf/${pdfId}`);
  return response.data;
};

// Update PDF by ID (sends new file as multipart/form-data)
export const updatePdf = async (pdfId, formData) => {
  const response = await api.post(`pdfs/update_pdf/${pdfId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// Get all lavajam entries
export const getAllLavajam = async (
  userId,
  startDate,
  endDate,
  createdById
) => {
  const payload = {
    userId,
    startDate,
    endDate,
    createdById: createdById === "all" ? 0 : createdById,
  };

  const response = await api.post("lavajam/get_lavajam_by_user_id", payload);
  return response.data;
};


// Get all daan entries
export const getAllDaan = async (
  userId,
  startDate,
  endDate,
  createdById
) => {
  const payload = {
    userId,
    startDate,
    endDate,
    createdById: createdById === "all" ? 0 : createdById,
  };

  const response = await api.post("daan/get_daan_by_user_id", payload);
  console.log(response.data)
  return response.data;
};


// Get All photos
export const getPhotos = async () => {
  const response = await api.get("homephotos");
  return response.data;
};

export const addPhoto = async (uploadData) => {
  try {
    const response = await api.post("homephotos/addphoto", uploadData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error during photo upload:", err);
    throw err.response?.data || { message: "Server error" };
  }
};

// Update photo by ID
export const updatePhoto = async (photoId, formData) => {
  const response = await api.put(`homephotos/${photoId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// Delete photo by ID
export const deletePhoto = async (photoId) => {
  const response = await api.delete(`homephotos/${photoId}`);
  return response.data;
};
